
export const APPLICATION_ID = 'ClientPortal';
